import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import usePageBackground from '../hooks/usePageBackground';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import { useFadeInOnScroll } from '../theme/global';
import * as endPoints from '../assets/js/endpoints';
import * as utils from '../assets/js/utils';
import Loader from '../components/loader';

const Article = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  const containerRef = useFadeInOnScroll([loading]);

  usePageBackground('blog-background-color');

  useEffect(() => {
    setLoading(true);
    endPoints.getArticle(id)
      .then(setArticle)
      .finally(() => setLoading(false));
  }, [id]);


  if (loading) return <Loader />;
  if (!article) return <Typography>Artículo no encontrado</Typography>;

  return (
    <>
    <Helmet>
      <title>Artículo del Blog | CES</title>
      <meta name="description" content="Detalle de un artículo publicado en nuestro blog." />
    </Helmet>
    <Container ref={containerRef} maxWidth="md" className="fade-up" sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        {article.title}
      </Typography>
      {article.image && (
        <Box
          component="img"
          src={utils.image_path(article.image)}
          alt={article.title}
          sx={{ width: '100%', maxHeight: 400, objectFit: 'cover', borderRadius: 2, mb: 2 }}
        />
      )}
      {article.service && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {article.service.name || article.service.title}
        </Typography>
      )}
      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', textAlign: 'justify' }}>
        {article.text}
      </Typography>
    </Container>
    </>
  );
};

export default Article;
